import {
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import {
  GridColDef,
  GridRenderCellParams,
  GridValueGetterParams,
} from "@mui/x-data-grid";
import * as React from "react";
import AddCircleIcon from "@mui/icons-material/AddCircleOutline";
import { Link } from "react-router-dom";
import {
  useGetCategoriesQuery,
  useGetManufacturersQuery,
  useGetProductsMutation,
} from "../../../../redux/reducer/features/Product/productSlice";
import AppConfirmDialog from "../../../app/AppConfirmDialog";
import {
  Product,
  ProductManufacturer,
} from "../../../../models/features/Product/Product";
import { LocationWholegood } from "../../../../models/features/Integration/DmsSetup";
import { useDispatch } from "react-redux";
import {
  addMatchedProduct,
  removeMissMatchProduct,
} from "../../../../redux/reducer/features/Integration/DmsSetupSlice";
import ServerAppGrid from "../../../app/ServerAppGrid";
import { AppFilter, AppFilterItem } from "../../../../models/app/AppModels";
import { DmsManufacturer } from "../../../../models/features/ShoppingPortal/DmsManufacturer";

interface MatchManuallyProps {
  isOpen: boolean;
  handleClose: any;
  setPopup: any;
  catalogManufacturers: ProductManufacturer[];
  onSave: any;
  selectedDmsLocation: DmsManufacturer | undefined;
}

const ManufacturerDialog: React.FunctionComponent<MatchManuallyProps> = ({
  handleClose,
  isOpen,
  setPopup,
  catalogManufacturers,
  onSave,
  selectedDmsLocation,
}) => {
  const [selectedManufacturer, setSelectedManufacturer] = React.useState<
    ProductManufacturer | undefined
  >();
  const manufacturerDefaultProps = {
    options: catalogManufacturers,
    getOptionLabel: (option: any) => option.shortTitle + " - " + option.title,
    getOptionValue: (option: any) => option.id,
  };

  return (
    <>
      <Dialog
        fullWidth
        open={isOpen}
        onClose={() => setPopup(false)}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle
          style={{ textAlign: "center" }}
          id="draggable-dialog-title"
        >
          Manufacturer Mapper
        </DialogTitle>
        <DialogContent sx={{ width: "auto" }}>
          <Typography fontSize="medium">
            <strong>
              DMS Manufacturer: {selectedDmsLocation?.code} -{" "}
              {selectedDmsLocation?.name}
            </strong>
          </Typography>
          <Typography fontSize="small">
            Select any Catalog Manufacturer from the followings to map with Dms
            Manufacturer.
          </Typography>
          <FormControl sx={{ mt: 1 }} fullWidth>
            <Autocomplete
              fullWidth
              {...manufacturerDefaultProps}
              id="clear-on-escape"
              clearOnEscape
              // loading={isLoading}
              // defaultValue={params.row.manufacturerId ?? ""}
              // value={params.row.catalogManufacturerId ?? ""}
              onChange={(e, value) => {
                if (value) setSelectedManufacturer(value);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="standard"
                  fullWidth
                  label="Catalog Manufacturer"
                />
              )}
            />
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button
            size="small"
            variant="outlined"
            autoFocus
            onClick={() => setPopup(false)}
          >
            Cancel
          </Button>
          <Button
            size="small"
            variant="contained"
            onClick={() => {
              onSave(selectedManufacturer);
              setPopup(false);
            }}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ManufacturerDialog;
